import { Directive, ElementRef, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[appAlphabetsWithdot]'
})
export class AlphabetsWithdotDirective {
maxlength = 30;
constructor(private ngControl: NgControl,private toastr : ToastrService) {}

@HostListener('input', ['$event.target.value'])
onInput(value: string) {
  let clean = '';
  clean = value.replace(/[^a-zA-Z0-9\._&-]/g, '');
  if(clean){
    if(clean.length > this.maxlength){
      this.toastr.error('User name should be less than or equal to '+this.maxlength+' characters');
    }
    clean = clean.slice(0, this.maxlength);
  }
  
  this.ngControl.control.patchValue(clean);
}

// private regex: RegExp = new RegExp(/^[a-zA-Z0-9\._]+$/);

}
